// @ts-nocheck
import { IChangeTaskEstimationInput } from '../models/IChangeTaskEstimationInput';
import { taskUrls } from '../apiUrls';
import axios from '../../../../services/api';
import { IChangeTaskReleaseEstimationInput } from '../models/IChangeTaskReleaseEstimationInput';

export const changeTaskEstimation = async (
  input: IChangeTaskEstimationInput
): Promise<{ success: boolean; error?: string }> => {
  try {
    await axios.post(taskUrls.changeTaskEstimation, input);
    return { success: true };
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : 'Error changing task estimation';
    return { success: false, error: errorMessage };
  }
};

export const changeTaskReleaseEstimation = async (
  input: IChangeTaskReleaseEstimationInput
): Promise<{ success: boolean; error?: string }> => {
  try {
    await axios.post(taskUrls.changeTaskReleaseEstimation, input);
    return { success: true };
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : 'Error changing task release estimation';
    return { success: false, error: errorMessage };
  }
};
